import React , {useState , useEffect} from 'react';
import { fetchTotalBicycleCount } from '../../stores/api_calls/dashboard';
import { GoUnverified } from "react-icons/go";
import {AiOutlineArrowRight} from 'react-icons/ai'
import './card.scss'
import { useNavigate } from 'react-router-dom';

const UnverifiedBicycleCard = () => {

    const navigate = useNavigate()
    const [total , setTotal] = useState("")
    const [isLoading , setIsLoading] = useState(false)

    useEffect(()=>{
        setIsLoading(true);

        const params = {
            product_status: "processing", // mean unverified
        }
        const getTotal = fetchTotalBicycleCount(params);

        getTotal.then((res)=>{
            if(res.data){
                if(res.data.success){
                    setTotal(res?.data?.data?.total_count)
                    setIsLoading(false)
                }
            }
        }).catch((e)=>{
            console.log(e)
        })
    },[])

    return (
        <div>
            <div className='total-unverified-bicycle header-card'>
                <p className='header-text'>Unverified Bicycles</p>
                <GoUnverified style={{width:"80px"}}/>
            </div>
            <div className='total-banner body-card'>
                <p className='active-text'>Total : {isLoading ? 'fetching' : !isLoading && total? total : 0}</p>
                <div className='goIcon' onClick={()=>navigate("/bicycles/unverified", { replace: true })}>
                    <AiOutlineArrowRight/>
                </div>
            </div>
        </div>
    )
}

export default UnverifiedBicycleCard;
